<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { authMethods } from './stores/auth.ts';

const router = useRouter();

onMounted(async () => {
  // For implicit flow, the access token is in the URL fragment
  const fragment = window.location.hash.substring(1);
  const params = new URLSearchParams(fragment);
  const accessToken = params.get('access_token');
  const error = params.get('error');

  if (error) {
    console.error("OAuth Error:", error);
    authMethods.logout();
    router.push('/dashboard');
    return;
  }

  if (!accessToken) {
    console.error("Access token not found in URL fragment.");
    router.push('/dashboard');
    return;
  }

  try {
    // Set the Google token immediately
    authMethods.setGoogleToken(accessToken);

    // Fetch user info with the access token
    const userResponse = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
      headers: { 'Authorization': `Bearer ${accessToken}` },
    });

    const userData = await userResponse.json();
    if (!userResponse.ok) throw new Error('Failed to fetch user data');

    authMethods.setGoogleUser(userData);
    
    // SECURITY: Clear the URL fragment to remove token from browser history
    window.history.replaceState(null, '', window.location.pathname);
    
    // Redirect to dashboard
    router.push('/dashboard');

  } catch (error) {
    console.error('Authentication Error:', error);
    authMethods.logout();
    router.push('/dashboard'); // Redirect to dashboard on error
  }
});
</script>

<template>
  <div>Authenticating...</div>
</template>